import { rgba } from 'polished';
import {
  sideNavBaseStyle,
  TSideNavTheme,
} from '../../base/customComponents/sideNav';

import { TStyleConfig } from '../../base/types';

export const SideNav: TStyleConfig<TSideNavTheme> = {
  baseStyle: (props) => {
    const base = sideNavBaseStyle(props);

    return {
      ...base,
      readableColor: 'white',
      bottomBorderRadius: base.borderBottomRadius,
      background: {
        boxShadow: 'lg',
        borderRadius: [null, null, null, '12px'],
        alignSelf: [null, null, null, 'flex-start'],
        overflow: 'hidden',
        w: 'auto',
        m: [null, null, null, '3px 22px'],
        mb: [null, null, null, '9px'],
        bg: 'linear-gradient(180deg, #2C3A56 0%, #202A3E 100%)',
      },
      drawer: {
        ...base.drawer,
      },
      drawerBody: {
        '> div, a': {
          ml: ['0', null, '2'],

          '> .dropDownInner, a[class*="dropDownInner"]': {
            _first: {
              borderColor: 'transparent',
              cursor: 'initial',
            },
            '&:hover, &:active': {
              bg: rgba(`${props.theme.colors.beta[500]}`, 0.8),
            },
          },
        },
      },
      icon: {
        ...base.icon,
        boxSize: '5',
        color: 'beta.500',
        fill: 'beta.500',
      },
      headerSX: {
        cursor: 'default',
        fill: 'delta.500',
        height: '45px',
        borderColor: 'black !important',
        borderBottom: '1px solid',
        '&:hover': {
          borderColor: 'transparent',
          bg: 'transparent',
        },
      },
      dropDownInner: {
        ...base.dropDownInner,
        px: '4',
      },
      linkSX: {
        ...base.linkSX,
      },
      link: {
        ...base.link,

        fontSize: 'sm',
        fontWeight: 'bold',
        height: '43px',
        transition: 'all, 0.2s linear',
        fontFamily: 'KHInterference',
        color: 'white',

        boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.15)',
        p: '4',
        ml: '0',
        borderColor: 'black !important',
        borderBottom: '1px solid',

        '~ .nested': {
          pl: '10',
        },

        ':hover': {
          borderLeftColor: 'epsilon.700',
          borderBottomColor: 'transparent',
          bg: ['transparent', null, null, 'blackAlpha.300'],
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          transition: 'all, 0.2s linear',
        },

        '.dropDownIcon': {
          fill: 'none',
        },
      },

      dropDownContainerClosed: {
        '.dropDownInner': {
          pl: ['4', null, '4'],
        },

        '> a, .dropDownIcon, a': {
          color: 'white',
        },

        '&:hover, &:active': {
          color: 'alpha.700',

          '.dropDownInner': {
            ...base.dropDownInner,
            px: '4',
            color: 'white',
          },

          '.svgIcon, .icon': {
            color: 'beta.500',
          },
        },
      },
      dropDownContainerOpen: {
        ...base.dropDownContainerOpen,

        p: '0',
        color: 'beta.500',

        _hover: {
          '.dropDownInner': {
            bg: 'epsilon.600',
          },
        },

        '.dropDownInner': {
          bg: 'epsilon.600',
          color: 'beta.500',
        },

        '> a, .dropDownIcon, a': {
          color: 'beta.500',
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          color: 'beta.500',
        },
      },
    };
  },
  sizes: {},
  variants: {},
};
